import SetupBaseController from '../common/setup.base.controller';
import AppConstants from '../../../../../config/app.constants';

class SetupEditController extends SetupBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, DateUtil, SetupService, Modal, $translate, $stateParams, BranchService, VaultService,
              $q, LocationService, RouteService, CurrencyService, UsersService, HomeService, $rootScope, WindowService, Configs, $timeout) {

    super(Auth, $state, User, SetupService, Modal, $translate, $stateParams);
    this.BranchService = BranchService;
    this.VaultService = VaultService;
    this.LocationService = LocationService;
    this.RouteService = RouteService;
    this.SetupService = SetupService;
    this.UsersService = UsersService;
    this.DateUtil = DateUtil;
    this.CurrencyService = CurrencyService;
    this.$q = $q;
    this.HomeService = HomeService;
    this.$rootScope = $rootScope;
    this.WindowService = WindowService;
    this.Configs = Configs;
    this.$timeout = $timeout;

    this.hasACL = {};
    this.errors = {};
    this.defaultModel = {
      branch: this.$stateParams.branch || this.User.getUser().branchId,
      isNonUSLocation: false,
      convertToPickup: false,
      availableCurrencyIds: [],
      branchCounters: [],
      serviceLocationTypes: ['ATM']
    };
    this.rawId = this.$stateParams.id;

    this.states = [
      "Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado",
      "Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia",
      "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
      "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts",
      "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
      "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
      "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico",
      "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
      "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
    ];

    this.HHTProtocolValues = [{
      label: 'W',
      value: 'W'
    },
    {
      label: 'D',
      value: 'D'
    }
    ];
    this.languages = [{
      value: 'E',
      label: "English"
    },
    {
      value: 'S',
      label: 'Spanish'
    }
    ];

    this.defaultServiceTicketAssignment = [
      { value: 'ROUTE', label: 'Route' },
      { value: 'USER', label: 'User' },
      { value: 'EXTERNAL', label: 'External' }
    ];
    this.serviceLocationTypeOptions = [
      { name: 'ATM', label: 'ATM' },
      { name: 'REGULAR', label: 'Regular' },
      { name: 'BANK', label: 'Bank' },
      { name: 'ON_CALL', label: 'On Call' },
      { name: 'NO_SHIP_NO_GO', label: 'No Ship No Go' }
    ];
    this.selectedServiceLocationTypes = [];
    this.updateServiceLocationTypes = () => {
      this.selectedServiceLocationTypes = this.serviceLocationTypeOptions.filter((option) => option.ticked);
      this.model.serviceLocationTypes = this.selectedServiceLocationTypes.map((option) => option.name);
    };
    this.selectNoneServiceLocationTypes = () => {
      this.$timeout(() => {
        const atmOption = this.serviceLocationTypeOptions.find((option) => option.name === 'ATM');
        this.serviceLocationTypeOptions.forEach((option) => {
          option.ticked = option === atmOption;
        });
        this.selectedServiceLocationTypes = [atmOption];
        this.model.serviceLocationTypes = ['ATM'];
      });
    };

    this.model = angular.copy(this.defaultModel)
    this.branches = [];
    this.vaults = [];
    this.locations = [];
    this.locationsScrollFlag = false;
    this.tankers = [];
    this.virtualTankers = [];
    this.routes = [];
    this.unassignedRoutes = [];
    this.currencys = [];
    this.currencyOptions = [];
    this.supervisors = [];
    this.isVaultDateChanged = false;
    this.setupData = {
      currentVaultDate: ""
    };

    this.passWdIcon = {
      exitPassword: false,
      confirmExitPassword: false
    }

    this.cenconLockOptions = [
      { label: 'RTE Mode', value: 'RTE' },
      { label: 'FLM Mode', value: 'FLM' }
    ];

    this.LMSLockOptions = [
      { label: 'Next Available', value: 'NA' },
      { label: '4 Hours', value: '4' },
      { label: '8 Hours', value: '8' },
      { label: '12 Hours', value: '12' },
      { label: 'Midnight', value: 'MN' }
    ];

    this.barCodeTypes = [
      { label: 'CODE_128', value: 'CODE_128' },
      { label: 'CODE_39', value: 'CODE_39' },
      { label: 'CODABAR', value: 'CODABAR' },
      { label: 'DATA_MATRIX', value: 'DATA_MATRIX' },
      { label: 'EAN_13', value: 'EAN_13' },
      { label: 'EAN_8', value: 'EAN_8' },
      { label: 'ITF', value: 'ITF' },
      { label: 'QR_CODE', value: 'QR_CODE' },
      { label: 'UPC_A', value: 'UPC_A' },
      { label: 'UPC_E', value: 'UPC_E' },
      { label: 'PDF417', value: 'PDF417' },
      { label: 'AZTEC', value: 'AZTEC' }
    ];

    this.userInfo = this.User.getUser();
    this.isVaultLiabilityChange = false;

    this.fromTankerObj = {
      results: [],
      totalRecords: 0
    };

    this.toTankerObj = {
      results: [],
      totalRecords: 0
    };

    this.windowObj = {
      results: [],
      totalRecords: 0
    };

    this.gettingSetupDetails = false;
    this.branchCost = [];
    this.deletedBranchCost = [];
    this.timezoneList = [];
  }

  mappingObjKeyVal(obj) {
    if (obj == null) return obj;
    obj.Key = obj.id + ' | ' + obj.name;
    obj.Value = obj.id;
    return obj;
  }

  $onInit() {
    this.loadDirective = false;
    this.gettingSetupDetails = true;
    this.isDuplicateBranchCost = true;
    this.isValidDistance = false;

    this.$q.all([
      this.Service.get(this.rawId),
      this.BranchService.all(null, 0, 100),
      this.VaultService.all(null, 0, 100),
      this.Service.all(null, 0, 100),
      this.CurrencyService.all(null, 0, AppConstants.defaultPageSize),
      this.momentTimeZone(),
    ])
      .then((data) => {
        this.defaultModel = data[0];
        this.model.defaultSupervisorId = this.mappingUserDatas([data[0].defaultSupervisor]);
        this.defaultModel.currentVaultDate = this.DateUtil.convertToDate(this.defaultModel.currentVaultDate);
        this.model = angular.copy(this.defaultModel);
        this.model.serviceLocationTypes = (Array.isArray(this.model.serviceLocationTypes) && this.model.serviceLocationTypes.length
          ? this.model.serviceLocationTypes
          : ['ATM']);
        this.serviceLocationTypeOptions.forEach((option) => {
          option.ticked = this.model.serviceLocationTypes.includes(option.name);
        });
        this.selectedServiceLocationTypes = this.serviceLocationTypeOptions.filter((option) => option.ticked);
        this.setupData.currentVaultDate = this.model.currentVaultDate;
        this.model.fromLocationId = this.mappingObjKeyVal(this.defaultModel.fromLocation);
        this.model.tankerId = this.mappingObjKeyVal(this.defaultModel.tanker);
        this.model.virtualTankerId = this.mappingObjKeyVal(this.defaultModel.virtualTanker);
        this.model.holdRouteId = this.mappingObjKeyVal(this.defaultModel.holdRoute);
        this.model.unassignedRouteId = this.mappingObjKeyVal(this.defaultModel.unassignedRoute);
        this.model.confirmExitPassword = this.model.exitPassword ? this.model.exitPassword : null;
        this.model.alertThreshold = this.model.alertThreshold ? this.model.alertThreshold + '%' : null;
        this.model.defaultWindowId = this.mappingObjKeyVal(this.defaultModel.defaultWindow);
        this.model.defaultFromTankerId = this.mappingObjKeyVal(this.defaultModel.defaultFromTanker);
        this.model.defaultToTankerId = this.mappingObjKeyVal(this.defaultModel.defaultToTanker);
        this.prefixes = Object.assign({ messenger: ["D"] }, this.model.prefixes);
				this.model.isNonUSLocation = this.model.country !== 'US' ? true : false;
        this.model.charactersRequired = this.model.pickupIdLength ? this.model.charactersRequired : 0, 
        this.loadDirective = true;
        this.branchCost = this.defaultModel.branchCost;
        this.prioritizeTimezone(this.model.timezone);
        this.branchCostData = _.cloneDeep(this.defaultModel.branchCost)
        this.model.locationOnHold = this.model.locationOnHold ? this.model.locationOnHold : false;
        const branchesWithExistingSetupRecord = data[3].results.map((setupRecord) => {
          return setupRecord.branchId;
        });

        this.branches = data[1].results
          .filter((branch) => !branchesWithExistingSetupRecord.includes(branch.id) || this.defaultModel.branchId.includes(branch.id))
          .map((branch) => branch.id);

        this.currencys = data[4].results.map((currency) => currency.id);
        this.vaults = data[2].results.map((vault) => vault.id);

        this.counters = (this.defaultModel.branchCounters || []).map(c => ({ 
          id: c.id, 
          name: c.name, 
          serialNumber: c.serialNumber,
          originalName: c.name,
          originalSerial: c.serialNumber
        }));
        this.newCounters = [];
        this.updatedCounters = [];
        this.deletedCounterIds = [];

        if (!Array.isArray(this.model.availableCurrencyIds) || !this.model.availableCurrencyIds.length) {
          this.model.availableCurrencyIds = [this.model.currencyId || this.currencys[0]];
        }

        this.currencyOptions = data[4].results.map((currency) => ({
          id: currency.id,
          ticked:this.model.availableCurrencyIds && this.model.availableCurrencyIds.includes(currency.id)
        }));

      })
      .then(() => {
        this.loadBranchData();
        this.getBranchSupervisors();
      })
      .finally(() => {
        this.gettingSetupDetails = false;
      })
  }

  momentTimeZone() {
    const timezone = this.mappingTimezone();
    this.timezoneList = this.timezoneList.concat(timezone);
    this.totalTimezones = this.timezoneList.length;
  }

  mappingTimezone() {
    return moment.tz.names().map((item) => {
      return { Key: item, Value: item }
    });
  }

  prioritizeTimezone(timezone) {
    if(!timezone) return;

    const existingIndex = this.timezoneList.findIndex(item => item.Value === timezone);
    
    if (existingIndex > -1) {
      this.timezoneList.splice(existingIndex, 1);
    }
    
    this.model.timezone = {
      Key: timezone,
      Value: timezone
    };
    
    this.timezoneList.unshift(this.model.timezone);
    this.totalTimezones = this.timezoneList.length;
  }

  searchSupervisorQuery() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: "supervisor",
            condition: "=",
            data: true
          }
        ],
        operator: "AND"
      }
    }
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  getBranchSupervisors() {
    this.Service.supervisorList(this.model.branchId)
      .then((data) => {
        this.supervisors = this.mappingUserDatas(data.results);
      })
      .catch(err => {
        console.log(err);
      })
  }

  mappingUserDatas(users) {
    return users.map((user) => {
      return {
        Key: user.userId + " | " + user.username,
        Value: user.userId
      }
    });
  }

  reset() {
    this.$onInit();
    delete this.errors['password'];
    this.isVaultDateChanged = false;
    if (!Array.isArray(this.model.availableCurrencyIds) || !this.model.availableCurrencyIds.length) {
          this.model.availableCurrencyIds = [this.model.currencyId || this.currencys[0]];
        }
  }

  submit(evt) {
    this.loading = true;

    this.errors = {};
    if (this.model.exitPassword && this.model.exitPassword !== this.model.confirmExitPassword) {
      this.errors['password'] = this.$translate.instant('setup.exitPasswordMismatch')
      return;
    }

    if (this.model.defaultFromTankerId && this.model.defaultToTankerId && this.model.defaultFromTankerId.Value === this.model.defaultToTankerId.Value) {
      this.loading = false;
      this.Modal.errorModal(this.$translate.instant('setup.tanker_error'));
      return;
    }

    if (!this.validateCounters()) {
      this.loading = false;
      return;
    }

    const branchCost = [];

    this.branchCost.forEach((bc) => {
      bc.name = bc.name;
      bc.startDistance = bc.startDistance;
      bc.endDistance = bc.endDistance;
      bc.standardLoad = bc.standardLoad;
      bc.ecLoad = bc.ecLoad;
      bc.setupId = bc.setupId;
      bc.branchId = bc.branchId;
      bc.createdByUserId = bc.createdByUserId;
      delete bc.isDuplicate;
      delete bc.isValid;
      branchCost.push(_.cloneDeep(bc));
    });

    const bc = this.findDifferences(this.branchCostData, branchCost)

    this.model.fromLocationId = this.model.fromLocationId.Value;
    this.model.tankerId = this.model.tankerId ? this.model.tankerId.Value : null;
    this.model.virtualTankerId = this.model.virtualTankerId ? this.model.virtualTankerId.Value : null;
    this.model.holdRouteId = this.model.holdRouteId ? this.model.holdRouteId.Value : null;
    this.model.unassignedRouteId = this.model.unassignedRouteId ? this.model.unassignedRouteId.Value : null;
    this.model.currentVaultDate = moment(this.model.currentVaultDate).format('YYYY-MM-DD');
    this.model.limitPerATMDeposit = this.model.limitPerATMDeposit ? this.model.limitPerATMDeposit : null;
    this.model.packCharLength = this.model.packCharLength || 0;
    this.model.isVaultDateChanged = this.isVaultDateChanged;
    this.model.oldVaultDate = moment(this.setupData.currentVaultDate).format('YYYY-MM-DD');
    this.model.gpsLat = this.model.gpsLat ? parseFloat(this.model.gpsLat) : 0.0;
    this.model.gpsLong = this.model.gpsLong ? parseFloat(this.model.gpsLong) : 0.0;
    this.model.limitPerRoute = this.model.limitPerRoute ? this.model.limitPerRoute : null;
    this.model.alertThreshold = this.model.alertThreshold ? this.convertStr(this.model.alertThreshold) : null;
    this.model.vaultLiability = this.model.vaultLiability ? this.model.vaultLiability : null;
    this.model.defaultWindowId = this.model.defaultWindowId ? this.model.defaultWindowId.Value : null;
    this.model.defaultFromTankerId = this.model.defaultFromTankerId ? this.model.defaultFromTankerId.Value : null;
    this.model.defaultToTankerId = this.model.defaultToTankerId ? this.model.defaultToTankerId.Value : null;
    this.model.country = this.model.isNonUSLocation ? this.model.country : 'US',
    this.model.branchCost = bc;
    this.model.deletedBranchCost = this.deletedBranchCost;
    this.model.userId =  this.User.getUser().id
    this.model.barcodeType = !this.model.autoDetectScannerCode ? this.model.barcodeType : null;
    this.model.checksumDigits = this.model.enforceChecksum ? this.model.checksumDigits : null;
    this.model.locationOnHold = this.model.locationOnHold ? this.model.locationOnHold : false;
    this.model.branchCost.forEach((d) => {
        d.modifiedByUserId = this.User.getUser().id
    });
    this.model.timezone = this.model.timezone ? this.model.timezone.Value : null;

    const validCounters = [];
    const newCounters = [];
    const updatedCounters = [];
    
    for (const c of this.counters) {
      const name = (c.name || '').trim();
      const serial = (c.serialNumber || '').trim();
      
      if (name && serial) {
        validCounters.push(c);
        
        if (!c.id) {
          newCounters.push(c);
        } else {
          const nameChanged = name !== (c.originalName || '').trim();
          const serialChanged = serial !== (c.originalSerial || '').trim();
          if (nameChanged || serialChanged) {
            updatedCounters.push(c);
          }
        }
      }
    }
    
    this.model.newCounters = newCounters;
    this.model.updatedCounters = updatedCounters;
    this.model.deletedCounterIds = this.deletedCounterIds;

    const payload = {...this.model};
    payload.serviceLocationTypes = this.selectedServiceLocationTypes.map((option) => option.name);

    payload.availableCurrencyIds = Array.isArray(this.model.availableCurrencyIds)
      ? this.model.availableCurrencyIds.map((o)=> o.id)
      : [];

    this.Service.update(this.rawId, payload)
      .then((data) => {
        const liabilityObj = {
          isVaultLiabilityChange: this.isVaultLiabilityChange,
          vaultLiability: this.calculateLability(this.model.vaultLiability, this.model.alertThreshold),
          branchId: this.model.branchId
        }
        this.$rootScope.$broadcast('updateBranchLiability', liabilityObj);
        window.history.go(-1);
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  loadBranchData() {
    this.loadInternalLocations('', 0);
    this.loadTanker('', 0);
    this.loadUnassignedRoutes('', 0);
    this.loadHoldRoutes('', 0);
    this.loadVirtualTanker('', 0);
    this.getBranchWindow('', 0);
    this.loadFromTanker('', 0);
    this.loadToTanker('', 0);
  }

  addCounter() {
    this.counters = this.counters || [];
    this.counters.push({ name: '', serialNumber: '' });
  }

  removeCounter(index) {
    const c = this.counters[index];
    if (c && c.id) this.deletedCounterIds.push(c.id);
    this.counters.splice(index, 1);
  }

  checkDuplicateSerials() {
    this.counters = this.counters || [];
    const serialSet = new Set();
    
    for (const c of this.counters) {
      const name = (c.name || '').trim();
      const serial = (c.serialNumber || '').trim();
      
      if (name && serial) {
        const serialLower = serial.toLowerCase();
        if (serialSet.has(serialLower)) {
          return true;
        }
        serialSet.add(serialLower);
      }
    }
    
    return false;
  }

  validateCounters() {
    if (this.checkDuplicateSerials()) {
      this.Modal.errorModal(this.$translate.instant('setup.duplicateSerial'));
      return false;
    }
    return true;
  }



  loadInternalLocations(searchKey, offset) {
    searchKey = searchKey || '';

    const locationSearchObj = {
      queryJSON: {
        rules: [{
          field: 'branchId',
          condition: '=',
          data: this.model.branchId
        },
        {
          field: 'locationType',
          condition: '=',
          data: 'INTERNAL'
        },
        {
          field: 'active',
          condition: '=',
          data: true
        },
        {
          group: {
            rules: [{
              field: 'id',
              condition: 'like',
              data: '%' + searchKey + '%'
            },
            {
              field: 'name',
              condition: 'like',
              data: '%' + searchKey + '%'
            }
            ],
            operator: 'OR'
          }
        }
        ],
        operator: 'AND'
      },
    }
    if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
      offset = offset - 1;
    }

    this.LocationService.getAllLocation(locationSearchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        let selectedVal = this.model.fromLocationId ? this.model.fromLocationId.Value : '';
        if (offset === 0 || offset == undefined) {
          this.totalLocation = data.total;
          this.locations = this.mapData(data.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            this.locations.unshift(this.model.fromLocationId);
          }
        } else {
          const locations = this.mapData(data.results, searchKey, selectedVal);
          this.locations = this.locations.concat(locations);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  getRoutes(searchKey, offset) {
    searchKey = searchKey || '';
    const routeSearchObj = {
      queryJSON: {
        rules: [{
          field: 'branchId',
          condition: '=',
          data: this.model.branchId
        },
        {
          group: {
            rules: [{
              field: 'id',
              condition: 'like',
              data: '%' + searchKey + '%'
            },
            {
              field: 'name',
              condition: 'like',
              data: '%' + searchKey + '%'
            }
            ],
            operator: 'OR'
          }
        }
        ],
        operator: 'AND'
      }
    };

    const routeDefer = this.$q.defer();
    this.RouteService.all(routeSearchObj, offset, AppConstants.defaultPageLimit)
      .then((routes) => {
        routeDefer.resolve(routes);
      })
      .catch((err) => {
        routeDefer.reject(err);
      })
    return routeDefer.promise;
  }

  loadHoldRoutes(searchKey, offset) {
    if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
      offset = offset - 1;
    }

    this.getRoutes(searchKey, offset)
      .then((data) => {
        let selectedVal = this.model.holdRouteId ? this.model.holdRouteId.Value : '';
        if (offset === 0 || offset == undefined) {
          this.totalRoute = data.total;
          this.routes = this.mapData(data.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            this.routes.unshift(this.model.holdRouteId);
          }
        } else {
          const routes = this.mapData(data.results, searchKey, selectedVal);
          this.routes = this.routes.concat(routes);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  loadUnassignedRoutes(searchKey, offset) {
    if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
      offset = offset - 1;
    }

    this.getRoutes(searchKey, offset)
      .then((data) => {
        let selectedVal = this.model.unassignedRouteId ? this.model.unassignedRouteId.Value : '';
        if (offset === 0 || offset == undefined) {
          this.totalUnassignedRoute = data.total;
          this.unassignedRoutes = this.mapData(data.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            this.unassignedRoutes.unshift(this.model.unassignedRouteId);
          }
        } else {
          const routes = this.mapData(data.results, searchKey, selectedVal);
          this.unassignedRoutes = this.unassignedRoutes.concat(routes);
        }
      })
      .catch(err => {
        console.log(err);
      })
  }

  // get tanker data
  loadTanker(searchKey, offset) {
    if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
      offset = offset - 1;
    }

    this.getTanker(searchKey, offset)
      .then(tankerData => {
        let selectedVal = this.model.tankerId ? this.model.tankerId.Value : '';
        if (offset === 0 || offset == undefined) {
          this.totalTanker = tankerData.total;
          this.tankers = this.mapData(tankerData.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            this.tankers.unshift(this.model.tankerId);
          }
        } else {
          const tankers = this.mapData(tankerData.results, searchKey, selectedVal);
          this.tankers = this.tankers.concat(tankers);
        }
      })
      .catch(err => {
        console.log(err);
      })
  }

  loadVirtualTanker(searchKey, offset) {
    if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
      offset = offset - 1;
    }
    this.getTanker(searchKey, offset)
      .then(tankerData => {
        let selectedVal = this.model.virtualTankerId ? this.model.virtualTankerId.Value : '';
        if (offset === 0 || offset == undefined) {
          this.totalVirtualTanker = tankerData.total;
          this.virtualTankers = this.mapData(tankerData.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            this.virtualTankers.unshift(this.model.virtualTankerId);
          }
        } else {
          const tankers = this.mapData(tankerData.results, searchKey, selectedVal);
          this.virtualTankers = this.virtualTankers.concat(tankers);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  getTanker(searchKey, offset) {
    searchKey = searchKey || '';
    const tankerSearchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          },
          {
            field: 'locationType',
            condition: '=',
            data: 'TANKER'
          },
          {
            field: 'active',
            condition: '=',
            data: true
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: "AND"
      }
    };

    let deferred = this.$q.defer();
    this.LocationService.getAllLocation(tankerSearchObj, offset, AppConstants.defaultPageLimit)
      .then((tankerData) => {
        deferred.resolve(tankerData)
      }).catch(e => deferred.reject(e));
    return deferred.promise;
  }

  mapData(mapArray, searchKey, originalVal) {
    let newArray = [];
    mapArray.map((obj) => {
      if (!searchKey && originalVal) {
        if (obj.id !== originalVal) {
          obj.Key = obj.id + " | " + obj.name;
          obj.Value = obj.id;
          newArray.push(obj);
        }
      } else {
        obj.Key = obj.id + " | " + obj.name;
        obj.Value = obj.id;
        newArray.push(obj);
      }
    });
    return newArray;
  }

  vaultDateChanged() {
    const keys = ['currentVaultDate'];
    this.isVaultDateChanged = keys.some((key) => {
      return moment(this.setupData[key]).format('YYYY-MM-DD') !== moment(this.model[key]).format('YYYY-MM-DD');
    });
  }

  showPassword(type) {
    this.passWdIcon[type] = !this.passWdIcon[type];
  }

  isAllowToChangeVaultSDate() {
    const config = this.Configs.getEnvironmentConfig();
    const usersString = config && config.permissions && config.permissions.changeVaultDate ? config.permissions.changeVaultDate.users : '';
    let hasConfigPerm = false;
    if (usersString) {
        const userList = usersString.split(',').map(u => u.trim().toLowerCase());
        const firstName = this.User.getUser().firstName ? this.User.getUser().firstName.trim().toLowerCase() : '';
        const lastName = this.User.getUser().lastName ? this.User.getUser().lastName.trim().toLowerCase() : '';
        
        const nameFormat1 = firstName + ' ' + lastName;
        const nameFormat2 = lastName + ' ' + firstName;
        hasConfigPerm = userList.includes(nameFormat1) || userList.includes(nameFormat2);
      }
    return hasConfigPerm;
  }

  ngPercentage() {
    if (this.model.alertThreshold && !this.model.alertThreshold.endsWith('%')) {
      return this.model.alertThreshold = this.model.alertThreshold + '%';
    }
  }

  convertStr(str) {
    if (!str || typeof str !== 'string') return;
    return Number(str.replace('%', ''));
  }

  removePrecentageSign() {
    if (this.model.alertThreshold && this.model.alertThreshold.endsWith('%')) {
      return this.model.alertThreshold = this.model.alertThreshold.replace('%', '');
    }
  }

  validateVaultLiability() {
    const currentLiability = this.defaultModel.vaultLiability;
    const currentAlertThreshold = this.defaultModel.alertThreshold;

    let updatedVaultLiability = this.model.vaultLiability ? this.model.vaultLiability : null;
    let updatedAlertThreshold = this.model.alertThreshold ? this.convertStr(this.model.alertThreshold) : null;

    if ((currentLiability !== updatedVaultLiability) || (currentAlertThreshold !== updatedAlertThreshold)) {
      this.isVaultLiabilityChange = true;
    }
    else this.isVaultLiabilityChange = false;
  }

  calculateLability(vaultLiability, alertThreshold) {
    if (!vaultLiability) return 0;
    else if (vaultLiability >= 0 && !alertThreshold) return vaultLiability;
    else if (!vaultLiability && !alertThreshold) return 0;
    else return Math.abs(((vaultLiability / 100) * alertThreshold).toFixed(2));
  }

  onPrintPack() {
    // this.model.printPrePack = !this.model.printPackLabel;
    if (this.model.printPackLabel && !this.model.printPrePack) {
      this.model.printPrePack = true;
    }
    else this.model.printPackLabel = this.model.printPackLabel;
  }

  onPrePrintPack() {
    // this.model.printPackLabel = !this.model.printPrePack;
    if (this.model.printPrePack && !this.model.printPackLabel) {
      this.model.printPackLabel = true;
    }
    else this.model.printPrePack = this.model.printPrePack;
  }

  getBranchWindow(searchKey, offset) {
    searchKey = searchKey || '';

    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          },
          {
            field: 'locationType',
            condition: '=',
            data: 'WINDOW'
          },
          {
            field: 'active',
            condition: '=',
            data: true
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }],
        operator: 'AND'
      }
    };

    return this.LocationService.getAllLocation(searchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.windowObj.results = this.mapData(data.results);
          this.windowObj.totalRecords = data.total;
        } else {
          const locations = this.mapData(data.results);
          this.windowObj.results = this.windowObj.results.concat(locations);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  loadFromTanker(searchKey, offset) {
    this.getTanker(searchKey, offset)
      .then(data => {
        if (offset === 0 || offset == undefined) {
          this.fromTankerObj.results = this.mapData(data.results);
          this.fromTankerObj.totalRecords = data.total;
        } else {
          const tankers = this.mapData(data.results);
          this.fromTankerObj.results = this.fromTankerObj.results.concat(tankers);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  loadToTanker(searchKey, offset) {
    this.getTanker(searchKey, offset)
      .then(data => {
        if (offset === 0 || offset == undefined) {
          this.toTankerObj.results = this.mapData(data.results);
          this.toTankerObj.totalRecords = data.total;
        } else {
          const tankers = this.mapData(data.results);
          this.toTankerObj.results = this.toTankerObj.results.concat(tankers);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  resetText() {
		this.model.state = null;
		this.model.country = null;
	}

  addNewCost(event) {
    this.branchCost.push({
      name: null,
      startDistance: null,
      endDistance: null,
      standardLoad: null,
      ecLoad: null,
      setupId: this.rawId,
      branchId: this.model.branchId,
      createdByUserId: this.User.getUser().id,
      modifiedByUserId: this.User.getUser().id,
      status:'Create'
    })
    event.preventDefault();
  }

  removeCost(index) {
    this.deletedBranchCost.push(this.branchCost[index].id)
    this.branchCost.splice(index, 1);
    this.validateDistance()
    this.validateBranchCost()
  }

  validateDistance() {
    this.branchCost.forEach(bc => bc.isValid = false);

    for (let i = 0; i < this.branchCost.length; i++) {
      const currentCost = this.branchCost[i];
      const startDistance = parseFloat(currentCost.startDistance);
      const endDistance = parseFloat(currentCost.endDistance);

      currentCost.isValid = startDistance >= endDistance;
    }

    this.isValidDistance = this.branchCost.some(bc => bc.isValid);
  }

  validateBranchCost() {
    this.branchCost = _.map(this.branchCost, (mainObj, mainObjIndex) => {
      mainObj.isDuplicate = false;
      let eq = _.find(this.branchCost, (compairObject, compairObjIndex) => {
        if (mainObjIndex > compairObjIndex) {
          return (compairObject.startDistance === mainObj.startDistance && compairObject.endDistance === mainObj.endDistance) ;
        }
      });
      if (eq) {
        mainObj.isDuplicate = true;
        return mainObj;
      } else {
        return mainObj;
      }
    });

    let isValid = this.branchCost.map((obj) => {
      if (obj.isDuplicate) return true;
    })

    this.isDuplicateBranchCost = isValid.indexOf(true) >= 0 ? false : true
  }

  findDifferences(obj1Array, obj2Array) {
    let resultObjects = [];

    obj2Array.forEach(obj2 => {
      let obj1 = obj1Array.find(o => o.id === obj2.id)
      if (obj1) {
        let isUpdated = this.compareObjects(obj1, obj2);
        let updatedObject = { ...obj2, status: isUpdated ? 'Update' : 'no Change' };
        resultObjects.push(updatedObject)
      }
      else {
        resultObjects.push({ ...obj2, status: 'Create' });
      }
    })

    return resultObjects;
  }

  compareObjects(obj1, obj2) {
    for (let key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
          if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
            return true;
          }
        }
        else if (obj1[key] !== obj2[key]) {
          return true;
        }
      }
    }
    return false;
  }

  isAllDataFilled() {
    return this.branchCost.every(bc => {
      return bc.name && (bc.startDistance !== null && bc.startDistance !== undefined && bc.startDistance !== "") &&
        (bc.endDistance !== null && bc.endDistance !== undefined && bc.endDistance !== "") &&
        (bc.standardLoad !== null && bc.standardLoad !== undefined && bc.standardLoad !== "") &&
        (bc.ecLoad !== null && bc.ecLoad !== undefined && bc.ecLoad !== "");
    })
  }
  onAvailableCurrenciesChange() {
  // Defensive: handle undefined or non-array
  if (!Array.isArray(this.model.availableCurrencyIds)) {
    this.model.availableCurrencyIds = [];
  }
  if (this.model.availableCurrencyIds.length === 1) {
    this.model.currencyId = this.model.availableCurrencyIds[0].id;
    return;
  }
  const currentCurrencyExists = this.model.availableCurrencyIds.some(curr => curr.id === this.model.currencyId);
  if (!currentCurrencyExists && this.model.availableCurrencyIds.length > 0) {
    this.model.currencyId = this.model.availableCurrencyIds[0].id;
  }
  }
    setPrimaryCurrency = function(currencyId) {
    this.model.currencyId = currencyId;
    };
  }

export default SetupEditController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/edit/setup.edit.controller.js